<div mat-dialog-title>{{ TranslationKeys.AdminSecurityGroupInfoTitle | translate }}</div>
@if (data) {
  <div mat-dialog-content>
    <div class="name-value-item">
      <div class="name">
        {{ TranslationKeys.AdminSecurityGroupInfoGroupName | translate }} <span class="value">{{ data.groupName }}</span>
      </div>
    </div>
    <div class="name-value-item">
      <div class="name">{{ TranslationKeys.AdminSecurityGroupInfoMembers | translate }}</div>
      @for (member of data.members; track member) {
        <div class="value">{{ member }}</div>
      }
    </div>
  </div>
}
<div mat-dialog-actions nimbusMaterialButtonsRow>
  <button nimbusSecondaryButton (click)="close()">{{ TranslationKeys.GeneralClose | translate }}</button>
</div>
